import ButtonGroup from "../../../../common/components/button-group/ButtonGroup";
import React, { ChangeEvent, Dispatch, SetStateAction } from "react";
import { ConfigSwitch } from "../../../../common/components/config-switch/ConfigSwitch";
import ConfigInputContainer from "../../../../common/components/ConfigInputContainer";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
import { IPresentationGameConfig } from "../../../../common/types";
import ConfigScreen from "../../../../common/components/game-screens/ConfigScreen";

interface Props {
    config: IPresentationGameConfig;
    changeConfig: Dispatch<SetStateAction<IPresentationGameConfig>>;
    backToDetails: () => void;
    nextToPlay: () => void;
}

export const ConfigComponent = ({
    config,
    changeConfig,
    backToDetails,
    nextToPlay,
}: Props) => {
    const { t } = useTranslation();

    const handleStateChange = (property: string) => (value: any) => {
        changeConfig((prevConfig) => ({
            ...prevConfig,
            [property]: value,
        }));
    };

    const handleInputChange =
        (property: string) =>
        (event: ChangeEvent<HTMLInputElement>): void => {
            handleStateChange(property)(event.target.value);
        };

    const optionsSlide = [
        { label: "5", value: 5 },
        { label: "10", value: 10 },
        { label: "20", value: 20 },
    ];
    const optionsDuration = [
        { label: "5s", value: 5 },
        { label: "7s", value: 7 },
        { label: "10s", value: 10 },
    ];
    const placeholderText = t(
        "games.presentation.settings.placeholders-name"
    ) as string;

    return (
        <ConfigScreen
            configTitlePath="games.presentation.settings.name"
            nextToPlay={nextToPlay}
            nextActionDisabled={
                !config.randomTopic && config.customTopic === ""
            }
            backToDetails={backToDetails}
            backButtonLabelPath="games.presentation.settings.buttons.info"
            nextButtonLabelPath="games.presentation.settings.buttons.play"
        >
            <ConfigInputContainer
                infoPath="games.presentation.info.info-topic"
                labelPath="games.presentation.settings.random-topic">
                <ConfigSwitch
                    onChange={handleStateChange("randomTopic")}
                    checked={config.randomTopic}
                />
            </ConfigInputContainer>
            {!config.randomTopic && (
                <ConfigInputContainer infoPath="games.presentation.info.info-slide">
                    <Input
                        placeholder={placeholderText}
                        bordered={false}
                        value={config.customTopic}
                        onChange={handleInputChange("customTopic")}
                    />
                </ConfigInputContainer>
            )}
            <ConfigInputContainer
                infoPath="games.presentation.info.info-count"
                labelPath="games.presentation.settings.slide-count">
                <ButtonGroup
                    onChange={handleStateChange("slideCount")}
                    value={config.slideCount}
                    options={optionsSlide}
                />
            </ConfigInputContainer>
            <ConfigInputContainer
                infoPath="games.presentation.info.info-slide"
                labelPath="games.presentation.settings.switch-slide">
                <ConfigSwitch
                    onChange={handleStateChange("autoNext")}
                    checked={config.autoNext}
                />
            </ConfigInputContainer>

            {config.autoNext && (
                <ConfigInputContainer
                    infoPath="games.presentation.info.info-duration"
                    labelPath="games.presentation.settings.duration">
                    <ButtonGroup
                        onChange={handleStateChange("duration")}
                        value={config.duration}
                        options={optionsDuration}
                    />
                </ConfigInputContainer>
            )}

            <ConfigInputContainer
                infoPath="games.presentation.info.info-instructions"
                labelPath="games.presentation.settings.show-instructions">
                <ConfigSwitch
                    onChange={handleStateChange("showInstructions")}
                    checked={config.showInstructions}
                />
            </ConfigInputContainer>
        </ConfigScreen>
    );
};
